import { useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import { useAuth } from "@/lib/AuthContext";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Button } from "@/components/ui/button";
import { Lock, ArrowRight } from "lucide-react";
import { toast } from "sonner";

const LOGO = "https://customer-assets.emergentagent.com/job_cec63a27-6a0f-4a75-b23c-f51d63e453bf/artifacts/nuiygtwq_ChatGPT%20Image%20May%2012%2C%202026%2C%2007_59_58%20AM.png";

export default function Login() {
  const { login } = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await login(email.trim(), password);
      toast.success("Welcome back");
      navigate("/dashboard");
    } catch (err) {
      const msg = err?.response?.data?.detail || "Login failed";
      toast.error(typeof msg === "string" ? msg : "Login failed");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen wood-bg flex items-center justify-center px-4 py-12">
      <div className="w-full max-w-md">
        <Link to="/" className="flex items-center justify-center gap-3 mb-8" data-testid="login-back-home">
          <img src={LOGO} alt="Trailhead Taps" className="h-14 w-14 object-contain" />
          <div className="text-center">
            <div className="font-display text-2xl font-bold text-[#F8F5F0] leading-tight">Trailhead Taps</div>
            <div className="text-[10px] uppercase tracking-[0.25em] text-[#c97b3a]">Admin Dashboard</div>
          </div>
        </Link>

        <form onSubmit={submit} data-testid="login-form" className="bg-[#f4ecd8] border-2 border-[#c97b3a]/30 p-8 space-y-5">
          <div className="flex items-center gap-2 text-[#c97b3a] mb-2">
            <Lock className="h-4 w-4" />
            <span className="text-xs uppercase tracking-[0.3em] font-semibold">Restricted access</span>
          </div>
          <h1 className="font-display text-3xl text-[#1f2e1f]">Sign in to manage bookings</h1>

          <div>
            <Label className="text-sm font-medium text-[#5a5245] mb-2 block">Email</Label>
            <Input data-testid="login-email" type="email" required value={email} onChange={(e) => setEmail(e.target.value)} placeholder="you@trailheadtaps.com" autoComplete="email" />
          </div>
          <div>
            <Label className="text-sm font-medium text-[#5a5245] mb-2 block">Password</Label>
            <Input data-testid="login-password" type="password" required value={password} onChange={(e) => setPassword(e.target.value)} placeholder="••••••••" autoComplete="current-password" />
          </div>

          <Button type="submit" data-testid="login-submit" disabled={loading} className="btn-orange w-full rounded-none py-6 text-base font-semibold">
            {loading ? "Signing in..." : <>Sign in <ArrowRight className="ml-2 h-4 w-4" /></>}
          </Button>

          <p className="text-[11px] text-center text-[#8c8577] italic">
            Customers — no login needed.{" "}
            <Link to="/" className="text-[#c97b3a] underline-offset-2 hover:underline">Head back to the site →</Link>
          </p>
        </form>
      </div>
    </div>
  );
}
